import { createContext, useState } from 'react';
import api from 'services/api';

export const DocumentosContext = createContext();

export const DocumentosProvider = ({ children }) => {
  const [documento, setDocumento] = useState(null);
  const [getLoading, setGetLoading] = useState(false);
  const [postLoading, setPostLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const getDocumento = async (id, cb) => {
    try {
      setGetLoading(true);
      setDocumento(null);
      const { data } = await api.get(`/Cadastros/Documento/${id}`, {
        params: {
          NFe: true,
          Cce: true,
          MDFe: true,
          Itens: true,
          Saida: true,
          Totais: true,
          Moedas: true,
          Entrada: true,
          Servico: true,
          Contrato: true,
          Registros: true,
          Financeiro: true,
          Exportacao: true,
          Importacao: true,
          Transportes: true,
          Equipamentos: true,
          PedidoCompras: true,
          CotacaoCompras: true,
          RequisicaoCompras: true,
        },
      });
      setDocumento(data);
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const postDocumento = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Documento', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const postDocumentos = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Documento/Multiple', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const deleteDocumento = async ({ id, cb }) => {
    try {
      setDeleteLoading(true);
      await api.delete(`/Cadastros/Documento/${id}`);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setDeleteLoading(false);
    }
  };

  const postAnexo = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Documento/Registro/Anexo', data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const deleteAnexo = async ({ id, cb }) => {
    try {
      setDeleteLoading(true);
      await api.delete(`/Cadastros/Documento/Registro/Anexo/${id}`);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setDeleteLoading(false);
    }
  };

  const postDocumentoItemEstrutura = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Documento/Item/EstruturaReset', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const postDocumentoItemProcesso = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Documento/Item/ProcessoReset', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const postDocumentoItemImposto = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Documento/Item/ImpostoReset', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const postDocumentoItemCfo = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Documento/Item/CfoReset', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const postEncerramento = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/MDFe/Encerramento', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const getDocumentoResumo = async (id) => {
    try {
      setGetLoading(true);
      const { data } = await api.get(`/Cadastros/Documento/Resumo/${id}`);
      setDocumento(data);
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const postDocumentoMidia = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Documento/Midia', data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const getApontamentos = async ({ params, cb = null }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get('/Producao/Ordens/Apontamentos', {
        params,
      });
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <DocumentosContext.Provider
      value={{
        documento,
        getLoading,
        postLoading,
        deleteLoading,
        postAnexo,
        deleteAnexo,
        getDocumento,
        postDocumento,
        postDocumentos,
        deleteDocumento,
        getApontamentos,
        postEncerramento,
        postDocumentoMidia,
        getDocumentoResumo,
        postDocumentoItemCfo,
        postDocumentoItemImposto,
        postDocumentoItemProcesso,
        postDocumentoItemEstrutura,
      }}
    >
      {children}
    </DocumentosContext.Provider>
  );
};
